var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import deepmerge from '@mui/utils/deepmerge';
import { getBrandColor, getBrandShadeAliasMap, getColorsFromTokens } from './colors';
export var createPalette = function (_a, tokens) {
    if (_a === void 0) { _a = {}; }
    var primary = _a.primary, secondary = _a.secondary, _b = _a.mode, mode = _b === void 0 ? 'light' : _b, overrides = __rest(_a, ["primary", "secondary", "mode"]);
    var tokenColors = getColorsFromTokens(tokens);
    var brandColor = getBrandColor(tokenColors, tokens.color_bg_brand_primary);
    var brandShadeAlias = getBrandShadeAliasMap(brandColor, tokens.color_bg_brand_primary);
    var defaultOptions = __assign(__assign({ mode: mode, primary: primary || __assign(__assign({}, brandColor), brandShadeAlias), secondary: secondary || __assign(__assign({}, brandColor), brandShadeAlias), text: {
            primary: tokens.color_fg_bold,
            secondary: tokens.color_fg_default,
            disabled: tokens.color_fg_default,
        }, default: {
            light: tokens.color_bg_state_neutral_subtle,
            main: tokens.color_bg_state_neutral,
            dark: tokens.color_fg_on_state_neutral_subtle,
        }, warning: {
            light: tokens.color_bg_state_caution_subtle,
            main: tokens.color_bg_state_caution,
            dark: tokens.color_fg_on_state_caution_subtle,
        }, error: {
            light: tokens.color_bg_state_danger_subtle,
            main: tokens.color_bg_state_danger,
            dark: tokens.color_fg_on_state_danger_subtle,
        }, danger: {
            light: tokens.color_bg_state_danger_subtle,
            main: tokens.color_bg_state_danger,
            dark: tokens.color_fg_on_state_danger_subtle,
        }, success: {
            light: tokens.color_bg_state_success_subtle,
            main: tokens.color_bg_state_success,
            dark: tokens.color_fg_on_state_success_subtle,
        }, info: {
            light: tokens.color_bg_state_info_subtle,
            main: tokens.color_bg_state_info,
            dark: tokens.color_fg_on_state_info_subtle,
        }, action: {
            disabledOpacity: 0.5,
            disabledBackground: tokens.color_bg_disabled,
            //TODO: This needs some work. It might not be used anywhere and we dont have a semantictoken for it.
            hover: mode === 'light'
                ? tokens.color_global_functional_light_neutral_400
                : tokens.color_global_functional_dark_neutral_300,
            hoverBackground: tokens.color_bg_interactive_hover,
            activeBackground: tokens.color_bg_interactive_pressed,
        }, background: {
            default: tokens.color_bg_page,
            paper: tokens.color_bg_layer,
            surface: tokens.color_bg_layer,
        }, border: {
            primary: tokens.color_border_bold,
            secondary: tokens.color_border_default,
            light: tokens.color_border_default,
            dark: tokens.color_border_bold,
        }, divider: tokens.color_border_default, grey: tokenColors.neutral, identicons: {
            default: {
                light: tokens.color_fg_identicon_subtlest,
                base: tokens.color_fg_identicon_subtle,
                dark: tokens.color_fg_identicon,
            },
            primary: {
                light: tokens.color_fg_identicon_highlight_subtlest,
                base: tokens.color_fg_identicon_highlight_subtle,
                dark: tokens.color_fg_identicon_highlight,
            },
        } }, tokenColors), tokens);
    return deepmerge(defaultOptions, overrides);
};
